import { memo, useMemo } from 'react'

import { MicOffOutlined, MicOutlined } from '@material-ui/icons'
import ShortcutTooltip from '@collaborate-health/uikit/components/ShortcutTooltip'

import useUserMicrophone from '@tabeeb/modules/presentation/hooks/useUserMicrophone'

import { ToggleMicrophone } from '@tabeeb/shared/constants/keyboardShortcuts'
import { useSelector } from '@tabeeb/store'
import { getCurrentCallUserId } from '@tabeeb/modules/presentation/selectors'
import { getUserById } from '@tabeeb/modules/../users/selectors'
import ToolbarButton from '../ToolbarButton'

const MuteUserMicrophoneToolbarButton = () => {
  const userId = useSelector<number>(getCurrentCallUserId)
  const user = useSelector((state) => getUserById(state, { Id: userId }))

  const { handleClick: onToggleMicrophone, isMuted, selectedCallUser, currentUserId } = useUserMicrophone({ user })

  const icon = useMemo(() => (isMuted ? MicOffOutlined : MicOutlined), [isMuted])

  return (
    <ShortcutTooltip
      title={isMuted ? 'Unmute microphone' : 'Mute microphone'}
      keys={selectedCallUser?.id === currentUserId ? ToggleMicrophone : []}
    >
      <ToolbarButton Icon={icon} onClick={onToggleMicrophone} />
    </ShortcutTooltip>
  )
}

export default memo(MuteUserMicrophoneToolbarButton)

